<div class="app-foot">
    <div class="app-foot">
        <div class="app-foot-links">
            <span *ngIf="!hideLink" >
                <a  [href]="href" target="_blank" class="app-foot-link" alt="FREQUENTLY ASKED QUESTIONS (opens in new window)" >
                    FREQUENTLY ASKED QUESTIONS
                  </a>
            </span>
            <span *ngIf="hideLink" class="app-foot-link"></span>
        </div>
    </div>  
</div>
